import { Link, useLocation } from "react-router-dom";
import { HardHat, Plus, History, Sparkles, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Header() {
  const loc = useLocation();
  const active = (p) => loc.pathname === p;
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-30 bg-white/85 backdrop-blur-xl border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-lg bg-[#0F2137] flex items-center justify-center">
            <HardHat className="w-5 h-5 text-[#F59E0B]" />
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-[#0F2137] text-lg">ChantiPlanning</div>
            <div className="font-mono-tech text-[10px] uppercase tracking-wider text-slate-500">
              Planning de chantier · IA
            </div>
          </div>
        </Link>
        <nav className="flex items-center gap-2">
          <Link to="/blog" data-testid="nav-blog" className="hidden sm:inline-flex">
            <Button
              variant={active("/blog") ? "default" : "ghost"}
              size="sm"
              className={active("/blog") ? "bg-[#0F2137]" : ""}
            >
              <BookOpen className="w-4 h-4 mr-1.5" />
              Blog
            </Button>
          </Link>
          <Link to="/tarifs" data-testid="nav-pricing">
            <Button
              variant={active("/tarifs") ? "default" : "ghost"}
              size="sm"
              className={active("/tarifs") ? "bg-[#0F2137]" : ""}
            >
              <Sparkles className="w-4 h-4 mr-1.5" />
              Beta gratuite
            </Button>
          </Link>
          <Link to="/historique" data-testid="nav-history">
            <Button
              variant={active("/historique") ? "default" : "ghost"}
              size="sm"
              className={active("/historique") ? "bg-[#0F2137]" : ""}
            >
              <History className="w-4 h-4 mr-1.5" />
              Historique
            </Button>
          </Link>
          <Link to="/nouveau" data-testid="nav-new-project">
            <Button size="sm" className="bg-[#F59E0B] hover:bg-[#D97706] text-[#0F2137] font-semibold">
              <Plus className="w-4 h-4 mr-1.5" />
              Nouveau planning
            </Button>
          </Link>
        </nav>
      </div>
    </header>
  );
}
